import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, AlertCircle } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="bg-accent text-white py-2 px-4 sticky top-0 z-50 shadow-md flex justify-center items-center gap-2 md:gap-4 text-xs md:text-sm font-bold tracking-wide cursor-pointer" onClick={scrollToOffer} data-id="element-347">
      <div className="flex items-center gap-2 animate-pulse" data-id="element-348">
        <AlertCircle className="w-4 h-4 fill-white text-accent" data-id="element-349" />
        <span className="uppercase" data-id="element-350">Oferta Relámpago: 93% OFF</span>
      </div>

      <div className="hidden md:block h-4 w-[1px] bg-white/40" data-id="element-351"></div>

      <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full" data-id="element-352">
        <Clock className="w-3 h-3" data-id="element-353" />
        <span className="tabular-nums" data-id="element-354">
          00:{timeLeft.minutes.toString().padStart(2, '0')}:
          {timeLeft.seconds.toString().padStart(2, '0')}
        </span>
      </div>

      <div className="hidden md:block h-4 w-[1px] bg-white/40" data-id="element-355"></div>

      <span className="underline decoration-white/50 underline-offset-2 hover:text-white/90 transition-colors hidden sm:inline" data-id="element-356">
        Reclama tu descuento ahora →
      </span>
    </div>;
}